function checkMediaLoadedForCard(card) {
  const mediaElements = card.querySelectorAll('img, video');
  let loadedCount = 0;

  if (mediaElements.length === 0) {
    card.classList.add('all-media-loaded');
    return;
  }

  const checkAndAddClass = () => {
    loadedCount++;
    if (loadedCount === mediaElements.length) {
      card.classList.add('all-media-loaded');
    }
  };

  mediaElements.forEach(media => {
    const isImageLoaded = media.tagName === 'IMG' && media.complete && media.naturalHeight !== 0;
    const isVideoLoaded = media.tagName === 'VIDEO' && media.readyState >= 3;

    if (isImageLoaded || isVideoLoaded) {
      checkAndAddClass();
    } else {
      const onLoad = () => {
        checkAndAddClass();
        media.removeEventListener('load', onLoad);
        media.removeEventListener('loadeddata', onLoad);
      };

      media.addEventListener('load', onLoad); 
      media.addEventListener('loadeddata', onLoad);
    }
  });
}

function checkAllMediaLoaded() {
  const mediaCards = document.querySelectorAll('.card__media');
  mediaCards.forEach(card => checkMediaLoadedForCard(card));
}

function observeNewCardMedia() {
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          if (node.classList.contains('card__media')) {
            checkMediaLoadedForCard(node);
          } else {
            const nestedCards = node.querySelectorAll?.('.card__media');
            nestedCards?.forEach(card => checkMediaLoadedForCard(card));
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

document.addEventListener('DOMContentLoaded', () => {
  checkAllMediaLoaded();
  observeNewCardMedia();
  document.querySelectorAll(".product__media-wrapper, .header-wrapper, .AnnouncementBar, .content_wrapper, .banner-wrap, .template-search").forEach((card) => {
    site_Observer.observe(card);
  });
});

 const site_Observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("loaded");
          site_Observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1,
    }
  );